import React, { Component } from 'react';
import { GoodsFilter, GoodsPhoto, NoResult } from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { DataContext } from '../../Layout';

/* 개발담당:양유빈
 * 화면기능:상품검색 카테고리 리스트
 * 세부설명:
*/

export class CategoryList extends Component {
    static displayName = CategoryList.name;
    static contextType = DataContext;

    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            CategoryMid: [],
            CategorySub: [],
            Mid_Cd: "",
            Sub_Cd: "",
            GoodsList:[]
        };
        this.CsName = Big3Common.ContentState;
        if (this.props.ContentState !== undefined) {
            this.SearchModel.Man_Cd = this.props.ContentState.ManCd;
           
        }
        this.GoodsFilterRef = React.createRef();
        this.handleMidNm_Click = this.handleMidNm_Click.bind(this);
        this.handleSubNm_Click = this.handleSubNm_Click.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.handle_onScroll = this.handle_onScroll.bind(this);
    }
    //초기화
    async componentDidMount() {

        //안드로이드 백버튼 제어
        window.addEventListener('scroll', this.handle_onScroll);
        this.SearchModel.Page_Number = 1;
        await this.CategoryDataCall();
        
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handle_onScroll);
    } 
    handle_onScroll() {
        if (Big3Common.WebConfig.ScrollEvent === false) {
            return false;
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
            Big3Common.WebConfig.ScrollEvent = false;
            this.handleAddMore_Click()
        }
    }
    //카테고리 호출
    async CategoryDataCall() {
        try {
            let manCd = this.SearchModel.Man_Cd;
            let Data = await Big3Common.Get(`api/Common/Common/GetCategoryMainCd/${manCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);

                 const CategoryMid = DataSet["categorymid"];
                 const CategorySub = DataSet["categorysub"];

                //상품 상세에서 리스트로 돌아왔을때 처리
                const propSearchModel = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchModel, "");
                if (propSearchModel !== "") {
                    this.SearchModel = propSearchModel;
                    await this.CallSearchGoodsList(propSearchModel.Mid_Cd, propSearchModel.Sub_Cd);
                     this.setState({
                            CategoryMid: CategoryMid,
                            CategorySub: CategorySub,
                            Mid_Cd: propSearchModel.Mid_Cd,
                            Sub_Cd: propSearchModel.Sub_Cd
                        });
                }
                else{
                    this.setState({
                            CategoryMid: CategoryMid,
                            CategorySub: CategorySub,
                            Mid_Cd: "",
                            Sub_Cd: ""
                        });
                    await this.CallSearchGoodsList("", "");
                }
            }
            else {
                console.log("등록된 카테고리가 없습니다.");
            }
        }
        catch (e) {
            console.log("CategoryDataCall: ", e)
        }
        return false;
    }
    SearchModel = {
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Goods_Nm: "",
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size
    }
    async FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;

        this.SearchModel.Page_Number = 1;
        await this.CallSearchGoodsList(this.state.Mid_Cd, this.state.Sub_Cd);
    }
    handelFilterInit() {
        this.GoodsFilterRef.current.handleClear_Click();
       
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;

        this.SearchModel.Page_Number = 1;
        this.CallSearchGoodsList(this.state.Mid_Cd, this.state.Sub_Cd);
    }
    //상품조회
    async CallSearchGoodsList(Mid_Cd, Sub_Cd, isAppend = false) {
        try {

            Big3Common.Util.LoadingOn();
            this.SearchModel.Mid_Cd = Mid_Cd
            this.SearchModel.Sub_Cd = Sub_Cd;
            let Data = await Big3Common.Post('api/Search/Goods/GetSearchGoodsCategoryList', this.SearchModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodsList;
                    DataList.map(list => GoodListPush.push(list));
                    this.setState({
                        GoodsList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    this.setState({
                        GoodsList: DataList,
                        TotalCount: TotalCount
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallSearchGoodsList", e);
        }
        finally {
            Big3Common.WebConfig.ScrollEvent = true;
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.CallSearchGoodsList(this.state.Mid_Cd, this.state.Sub_Cd,true);
    }
    async handleMidNm_Click(event, Mid_Cd) {
        this.setState({ Mid_Cd: Mid_Cd, Sub_Cd: "" });
        this.SearchModel.Page_Number = 1;
        await this.CallSearchGoodsList(Mid_Cd,"");
        event.preventDefault();
    }
    async handleSubNm_Click(event, Mid_Cd, Sub_Cd) {
        if (Mid_Cd === "" && Sub_Cd === "" && this.state.Mid_Cd !== "" && this.state.Sub_Cd !== "") {
            this.setState({ Mid_Cd: this.state.Mid_Cd, Sub_Cd: "" });
            this.SearchModel.Page_Number = 1;
            await this.CallSearchGoodsList(this.state.Mid_Cd,"");
        }
        else {
            this.setState({ Mid_Cd: Mid_Cd, Sub_Cd: Sub_Cd });
            this.SearchModel.Page_Number = 1;
            await this.CallSearchGoodsList(Mid_Cd, Sub_Cd);
        }       
        event.preventDefault();
    }
    
    //상품상세보기 클릭
    async handleGoodsDtl_Click(e, goods_no, uid) {
        this.context.Layout_GoodsDtl(
        {
                goods_no: goods_no,
                uid: uid,
                isshow: true,
                headhide: true,
                scrollevent: false
        });
    }
    GetSwiperClassName(short_text, Type, list) {
        
        let len = short_text.length;
        let Css = `category `;
        if (len < 2) {
            Css += `category${3 - 1}`;
        }
        else if (len > 3) {
            Css += `category${len - 1}`;
        }
        else {
            Css += " category1";
        }

        if (Type === 'Mid' && this.state.Mid_Cd === list.mid_cd) {
            Css += " selected";
        }
        
        if (Type === 'Sub' &&  this.state.Mid_Cd === list.mid_cd && this.state.Sub_Cd === list.sub_cd) {
            
            Css += " selected";
        }
        else if (Type === 'Sub' &&  this.SearchModel.Mid_Cd ===list.mid_cd && this.state.Sub_Cd === list.sub_cd) {
            
            Css += " selected";
        }
        return Css;
    }
    Categoryrender() {
        let CategoryMid = this.state.CategoryMid;
        let CategorySub = this.state.CategorySub;
        let slidersCount = 4;
        if (this.state.Mid_Cd !== "") {
            CategorySub = this.state.CategorySub.filter(list => list.mid_cd === this.state.Mid_Cd);
        }
       
        return (
            <>
                <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="middle_category_box">
                    <SwiperSlide className={this.state.Mid_Cd === "" ? "category category1 selected" : "category category1"} onClick={(e) => { this.handleMidNm_Click(e,'')}}>
                        <div>전체</div>
                    </SwiperSlide>
                    {
                        CategoryMid.map((list, idx) =>
                            <SwiperSlide className={this.GetSwiperClassName(list.mid_nm,'Mid', list)} key={idx} onClick={(e) => { this.handleMidNm_Click(e,list.mid_cd)}}>
                                <div >{list.mid_nm.trim()}</div>
                            </SwiperSlide>
                        )}
                    <SwiperSlide>
                        {/* 공백*/}
                    </SwiperSlide>
                </Swiper>

                <Swiper watchSlidesProgress={true} slidesPerView={5} className="small_category_box">
                    <SwiperSlide className={this.state.Sub_Cd === "" ? "category category1 selected" : "category category1"} onClick={(e) => { this.handleSubNm_Click(e, '','') }}>
                        <div>전체</div>
                    </SwiperSlide>
                    {
                        CategorySub.map((list, idx) =>
                            <SwiperSlide className={this.GetSwiperClassName(list.sub_nm + ' ','Sub',list)} key={idx} onClick={(e) => { this.handleSubNm_Click(e, list.mid_cd,list.sub_cd) }}>
                                <div>{list.sub_nm}</div>
                            </SwiperSlide>

                        )}
                    <SwiperSlide>
                        {/* 공백*/}
                    </SwiperSlide>
                </Swiper>
            </>
        )
    }
    render() {
        let Categoryrender = this.Categoryrender();
        let GoodsList = this.state.GoodsList;
        return (
            <>
                <div id="parent_goods_list">
                    <div className="p_margin u_padding container_box" ref={this.refSearchList}>
                        {Categoryrender}
                        <div className="recent_product result_box">
                            <div className="select_box">
                                <div className="category_box filter"
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category filter">필터</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box reset" onClick={this.handelFilterInit}>
                                    <div className="category">초기화</div>
                                    <div className="reset_btn"></div>
                                </div>
                            </div>
                            <div className="recent_poroducts row row-cols-3 result">
                                {GoodsList.map((list,idx) =>
                                    <div className="product" key={idx} onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}>
                                        <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                            Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                            CallBack={this.CallBoorkMarkGoodsData}
                                            SoldoutYn={list.soldout_yn}
                                            SimilarityYn="Y"
                                        />
                                        <div className="shop_name">{list.org_nm}</div>
                                        <div className="product_name">{list.goods_nm}</div>
                                        <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                        {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                                    </div>
                                )}
                                {this.state.TotalCount === this.state.GoodsList.length ? <div className="more_btn_box"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                            </div>
                        </div>
                        <GoodsFilter
                            id="GoodsFilter"
                            CallBack={this.FilterCallback}
                            ref={this.GoodsFilterRef}
                        />
                        <NoResult
                            Visible={this.state.GoodsList.length === 0 ? true : false}
                            Top={"60%"}
                        />
                    </div>
                </div>
            </>
        );
    }
}
